import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingList: false,
  loadingPeriodicitys: false,
  loadingById: false,
  saveLoading: false,
  periodicitysLength: 0,
  periodicitys: [],
  periodicityList: [],
  periodicity: {},
  periodicityError: "",
  formError: "",
};

export default function PeriodicityReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PERIODICITY:
      return { ...state, loading: action.payload };
    case actions.LOADING_PERIODICITY_LIST:
      return { ...state, loadingList: action.payload };
    case actions.LOADING_PERIODICITYS:
      return { ...state, loadingPeriodicitys: action.payload };
    case actions.LOADING_PERIODICITY_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_PERIODICITY:
      return { ...state, saveLoading: action.payload };
    case actions.GET_PERIODICITY:
      return {
        ...state,
        periodicitys: action.payload.periodicitys,
        periodicitysLength: action.payload.periodicitysLength,
      };
    case actions.GET_PERIODICITY_LIST_BY_ID:
      return {...state, periodicityList: action.payload};
    case actions.GET_PERIODICITY_BY_ID:
      return {
        ...state,
        periodicity: action.payload,
      };
    case actions.GET_PERIODICITYS_BY_ID:
      return {
        ...state,
        periodicitys: action.payload,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.PERIODICITY_FAIL:
      return { ...state, periodicityError: action.payload };
    default:
      return state;
  }
}
